<template>
    <div class="root">
        <div class="d-flex" style="width: 100%; padding: 12px">
            <hr width="40%" color="midnightblue" size="1">
            <span class="allTxt">The crew</span>
            <hr width="40%" color="midnightblue" size="1">
        </div>
        <div class="profileContainer">
            <template v-for="(i, j) in 3">
                <div class="line" :key="j">
                    <profile v-for="(x, y) in 2" :key="y" :profileInfo="infos[j * 2 + y]"/>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import profile from '@/components/profile.vue';

const infos = [
    {
        'name': 'Rastoin Paul',
        'side': 'Dev'
    },
    {
        'name': 'Becerril Frederic',
        'side': 'Dev'
    },
    {
        'name': 'XVI Louis',
        'side': 'Dev'
    },
    {
        'name': 'Frech Remi',
        'side': 'Graphist'
    },
    {
        'name': 'D\'Ivan',
        'side': 'Scenarist'
    },
    {
        'name': 'Theo dort',
        'side': 'Scenarist'
    }
]

export default {
    name: 'crew',
    components: {
        profile,
    },
    data() {
        return {
            infos,
        }
    }
}
</script>

<style lang="stylus" scoped>

.root {
    margin-top: 32px;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    .profileContainer {
        width: 80%;
        display: flex;
        flex-wrap: wrap;
        .line {
            display: flex;
            width: 100%;
        }
    }
}
</style>